import type { AxiosInstance } from 'axios'
import type {
  FavoriteRationBody,
  FavoriteRationType,
  FavoriteRecipeBody,
  FavoriteRecipeType,
  FavoriteWorkoutPlanBody,
  FavoriteWorkoutPlanType,
} from 'src/types/favorites'


export class FavoritesApi {
  api: AxiosInstance

  urls = {
    favoriteRations: () => 'favorite-ration/' as const,
    favoriteRation: (id: FavoriteRationType['id']) => `favorite-ration/${id}/` as const,
    favoriteRecipes: () => 'favorite-recipes/' as const,
    favoriteRecipe: (id: FavoriteRecipeType['id']) => `favorite-recipes/${id}/` as const,
    favoriteWorkoutPlans: () => 'favorite-workout-plans/' as const,
    favoriteWorkoutPlan: (id: FavoriteWorkoutPlanType['id']) => `favorite-workout-plans/${id}/` as const,
}

  constructor(api: AxiosInstance) {
    this.api = api
  }

  getFavoriteRations = async (): Promise<FavoriteRationType[]> => {
    const response = await this.api.get<FavoriteRationType[]>(this.urls.favoriteRations())
    return response.data
  }

  postFavoriteRation = async (body: FavoriteRationBody): Promise<FavoriteRationType> => {
    const response = await this.api.post<FavoriteRationType>(this.urls.favoriteRations(), body)
    return response.data
  }

  deleteFavoriteRation = async (id: FavoriteRationType['id']) => {
    return await this.api.delete(this.urls.favoriteRation(id))
  }

  getFavoriteRecipes = async (): Promise<FavoriteRecipeType[]> => {
    const response = await this.api.get<FavoriteRecipeType[]>(this.urls.favoriteRecipes())
    return response.data
  }

  postFavoriteRecipe = async (body: FavoriteRecipeBody): Promise<FavoriteRecipeType> => {
    const response = await this.api.post<FavoriteRecipeType>(this.urls.favoriteRecipes(), body)
    return response.data
  }

  deleteFavoriteRecipe = async (id: FavoriteRecipeType['id']) => {
    return await this.api.delete(this.urls.favoriteRecipe(id))
  }

  getFavoriteWorkoutPlans = async (): Promise<FavoriteWorkoutPlanType[]> => {
    const response = await this.api.get<FavoriteWorkoutPlanType[]>(this.urls.favoriteWorkoutPlans())
    return response.data
  }

  postFavoriteWorkoutPlan = async (body: FavoriteWorkoutPlanBody): Promise<FavoriteWorkoutPlanType> => {
    const response = await this.api.post<FavoriteWorkoutPlanType>(this.urls.favoriteWorkoutPlans(), body)
    return response.data
  }

  deleteFavoriteWorkoutPlan = async (id: FavoriteWorkoutPlanType['id']) => {
    return await this.api.delete(this.urls.favoriteWorkoutPlan(id))
  }
}
